// Format date to "Idag", "9 sept" or "9 sept 2024"
export const formatRelative = (
  _date: string,
  locale?: string,
  timeZone?: string
) => {
  const date = new Date(_date);
  const today = new Date();

  if (date.toDateString() === today.toDateString()) {
    return "Idag";
  }

  return formatShortDate(date, locale, timeZone);
};

const SHORT_MONTHS = [
  "jan",
  "feb",
  "mars",
  "apr",
  "maj",
  "juni",
  "juli",
  "aug",
  "sept",
  "okt",
  "nov",
  "dec",
];

// Format date to "9 sept", or "9 sept 2024" when not the current year.
// Month names are hardcoded so server and browser render the same string.
const formatShortDate = (date: Date, locale?: string, timeZone?: string) => {
  const getParts = (d: Date) => {
    const parts = new Intl.DateTimeFormat(locale, {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      timeZone,
    }).formatToParts(d);
    const get = (type: string) =>
      Number(parts.find((part) => part.type === type)?.value);
    return { year: get("year"), month: get("month"), day: get("day") };
  };

  const { year, month, day } = getParts(date);
  const label = `${day} ${SHORT_MONTHS[month - 1]}`;

  return year === getParts(new Date()).year ? label : `${label} ${year}`;
};

// Format date to "12:33"
export const formatTime = (
  _date: string | number | Date,
  locale?: string,
  timeZone?: string
) => {
  const date = new Date(_date);

  return new Intl.DateTimeFormat(locale, {
    hour: "2-digit",
    minute: "2-digit",
    timeZone,
  }).format(date);
};

// Format date to "9 sept."
export const formatMonthDay = (
  _date: string,
  locale?: string,
  timeZone?: string
) => {
  const date = new Date(_date);

  return new Intl.DateTimeFormat(locale, {
    month: "short",
    day: "numeric",
    timeZone,
  }).format(date);
};

// Format date to "6 augusti 2024, 14:00"
export const formatDate = (
  _date: string,
  locale?: string,
  timeZone?: string
) => {
  const date = new Date(_date);

  const formattedDate = new Date(date).toLocaleDateString(locale, {
    day: "numeric",
    month: "short",
    year: "numeric",
    timeZone,
  });

  const timeParts = new Intl.DateTimeFormat(locale, {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
    timeZone,
  }).formatToParts(date);

  const formattedTime = timeParts.map((part) => part.value).join("");

  return `${formattedDate}, ${formattedTime}`;
};

export const localDate = (_date?: string | number | Date) => {
  return new Date(
    new Date(_date ? _date : Date.now()).toLocaleString("sv-SE", {
      timeZone: "Europe/Stockholm",
    })
  );
};
